<template>
  <div>
    <messages messageType="outbox" />
  </div>
</template>

<script>
import Messages from '@/components/pages/Messages/Messages'

export default {
  name: 'sent-messages',

  components: {'messages': Messages}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Messages/SentMessages.vue